import media from "@/utils/media";
import styled from "styled-components";

const Card = styled.div`
  border-radius: 10px;
  ${media.tablet`
    background-color: white;
    padding: 20px 30px;
  `}
`;

export default Card;
